/**
 * The role a template item's auto-assignment actually runs through. A fixed
 * assignee (autoAssignEmail) or excludeFromAutoAssign overrides the role, so
 * such items are NOT "research items" for bulk reassignment even when the
 * template tags them research.
 */
export function governingRole(t) {
    if (t.excludeFromAutoAssign)
        return null;
    if (t.autoAssignEmail)
        return null;
    return t.autoAssignRole ?? null;
}
/**
 * A checklist item's role: the stored `autoAssignRole` when present, else
 * (for items created before that field existed) the role of the template
 * item it was copied from. Manual, AI and Asana-imported items have no role.
 *
 * Which template governs a legacy item depends on how it got there:
 *   - Instantiated items keep the template item's id (`id === sourceRef`),
 *     and were copied from the version snapshot recorded on the checklist.
 *   - Items from a section added later via addSectionFromTemplate get a
 *     fresh id (`id !== sourceRef`) and were copied from the live default
 *     template at that moment, which no snapshot records; the current
 *     default is the closest available approximation.
 * Each falls back to the other template when its own is unavailable.
 */
export function effectiveAutoAssignRole(item, templates) {
    if (item.autoAssignRole !== undefined)
        return item.autoAssignRole;
    if (item.source !== "template" || !item.sourceRef)
        return null;
    const copiedAtInstantiation = item.id === item.sourceRef;
    const ordered = copiedAtInstantiation
        ? [templates.instantiated, templates.current]
        : [templates.current, templates.instantiated];
    const template = ordered.find((t) => !!t);
    if (!template)
        return null;
    const t = template.items.find((x) => x.id === item.sourceRef);
    return t ? governingRole(t) : null;
}
